<template>
  <div class="ly_header" v-if="page !== 'start'">
      <a href="#" class="el_exitBtn" @click="openExit()">おわる</a>
      <Exit v-if="exit" @close="closeExit()"/>
  </div>
</template>

<script>
import Exit from '@/components/Exit';
import { mapState } from 'vuex';

export default {
  name: 'layout',
  components: {
    Exit,
  },
  data() {
    return {
      exit: false,
    };
  },
  computed: {
    ...mapState('currentPage', [
      'page',
    ]),
  },
  methods: {
    openExit() {
      this.exit = true;
    },
    closeExit() {
      this.exit = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ly_header{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 0;
  top: 0;
  height: 70px;
  z-index: 10;

  .el_exitBtn{
    box-sizing: border-box;
    display: block;
    border-radius: 0 0 10px 0;
    box-shadow: 1px 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #4a495b;
    font-size: 33px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 10px 30px 12px 31px;
    width: 160px;
    vertical-align: middle;

    &:hover{
      background-color: #5f5e73;
    }
  }
}

@media screen and (max-width: 768px){
  .ly_header{
    height: 50px;

    .el_exitBtn{
      width: 80px;
      font-size: 16px;
      padding: 10px 15px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue